import type {
  TWellLogsManagerSerializedInternalState,
  WellLogsManagerWidgetEntity,
} from '../../../pages/dashboard/features/well-logs-manager-widget/WellLogsManagerWidget.entity';

export function serializeWellLogsManagerTemplate(widget: WellLogsManagerWidgetEntity) {
  const internalState: TWellLogsManagerSerializedInternalState = {
    wellId: null,
    stateParams: widget.stateParams,
  };
  return {
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    internalState,
  };
}
